<!-- <template>
    <div id="specifications" class="tab-pane fade pb-3" :class="activeTab === 'specifications' ? 'in active show' :''">
        <div class="">
          <table class="table table-bordered fontsize-small">
            <tbody>
              <tr v-for="specification in product.specifications" :key="specification.id">
                <th scope="row" class="bg-color-fa text-center w-25 "> {{specification.label != null ? specification.label : specification.name }}</th>
                <td class="text-right pr-4">
                  <template v-if="specification.pivot && specification.pivot.specification_values != ''">
                    <span v-for="(values, index) in specification.pivot.specification_values" :key="index"> {{values.value }} {{index != specification.pivot.specification_values.length - 1 ? '-' : ''}} </span>
                  </template>
                  <template v-else-if="specification.pivot && specification.pivot.specification_value">
                    {{ specification.pivot.specification_value.value }}
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
</template>
<script>
export default {
  name: 'ProductSpecifications',
  props:['activeTab' , 'product'],
}
</script>
<style scoped>
@media screen and (max-width: 768px) {
  table tr th:first-child {
    min-width: 140px;
    text-align: right!important;
  }
}
</style> -->


<template>
  <div id="specifications" class="tab-pane fade pb-3" :class="activeTab === 'specifications' ? 'in active show' :''">
      <div class="w-100 d-flex justify-content-start justify-content-md-center " style="overflow-y: auto;">
        <table class="table  fontsize-small">
          <tbody>
            <tr v-for="specification in product.specifications" :key="specification.id">
              <th scope="row" class=" text-center w-25 "> {{specification.label != null ? specification.label : specification.name }}</th>
              <td class="text-right pr-4 ">
                <template v-if="specification.pivot && specification.pivot.specification_values != ''">
                  <span v-for="(values, index) in specification.pivot.specification_values" :key="index"> {{values.value }} {{index != specification.pivot.specification_values.length - 1 ? '-' : ''}} </span>
                </template>
                <template v-else-if="specification.pivot && specification.pivot.specification_value">
                  {{ specification.pivot.specification_value.value }}
                </template>
                <template v-else-if="specification.pivot && specification.pivot.value">
                  {{ specification.pivot.value }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>
<script>
export default {
name: 'ProductSpecifications',
props:['activeTab' , 'product'],
}
</script>
<style scoped>
#specifications{

padding-top: 2rem;
}
.table{
max-width: 800px ;
}

table tbody tr:nth-child(odd) th ,table tbody tr:nth-child(odd) td{
background-color:var(--color-fa);
background-color:#c7c7c736;
}
table *{
border: unset !important;
white-space: nowrap ;
}
@media screen and (max-width: 1000px) {

.table{
  max-width: 100% ;
}
}
@media screen and (max-width: 768px) {
table tr th:first-child {
  min-width: 140px;
  text-align: right!important;
}

}
</style>
